import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const CONTRACT = {
  getALlCommodityList: {
    success: "CONTRACT_GET_ALL_SUCCESS",
    error: "CONTRACT_GET_ALL_ERROR"
  },
  getCommodityVariertyList: {
    success: "GET_ALL_VARIETY_SUCCESS"
  },
  getAllCounterpartList: {
    success: "GET_ALL_COUNTERPART_SUCCESS"
  },
  getAllContractStageList: {
    success: "GET_ALL_CONTRACT_STAGE_SUCCESS"
  },
  getAllContractTypeList: {
    success: "GET_ALL_CONTRACT_TYPE_SUCCESS"
  },
  getAllContractsList: {
    start: "GET_ALL_CONTRACT_START",
    success: "GET_ALL_CONTRACT_SUCCESS"
  },
  getContractsList: {
    start: "GET_CONTRACTS_START",
    success: "GET_CONTRACTS_SUCCESS"
  },
  getDestinationByType: {
    success: "GET_ALL_CONTRACT_DESTINATION_SUCCESS"
  },
  InternalDestinationList: {
    success: "GET_ALL_CONTRACT_INTERNAL_DESTINATION_SUCCESS"
  },
  create: {
    success: "CONTRACT_CREATE_SUCCESS",
    error: "CONTRACT_CREATE_ERROR"
  },
  edit: {
    success: "CONTRACT_EDIT_SUCCESS",
    selected: "EDIT_SELCTED_CONTRACT"
  },
  delete: {
    success: "CONTRACT_DELETE_SUCCESS"
  },
  selectedContractDetails: {
    success: "SELECTED_CONTRACT_DETAIL_SUCCESS"
  },
  setSearchTerm: {
    success: "SET_SEARCH_TERM_SUCCESS"
  }
};

export const getAllContractList = (
  id,
  harvestYear = harvestYearDetail().name
) => {
  console.log("l");
  let url = `/ntrac/contract/farmId/${id}?harvestYear=${harvestYear}`;
  return dispatch => {
    return globalApiHandler(url, "get", {}, dispatch)
      .then(response => {
        const responseData = response.data.data;
        const suggestedResponseData = response.data.suggestedData;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] = responseData[value].contractNumber;
          return responseData[value];
        });

        let suggestedData = Object.keys(suggestedResponseData).map(value => {
          suggestedResponseData[value]["name"] =
            suggestedResponseData[value].contractNumber;
          return suggestedResponseData[value];
        });
        dispatch({
          type: CONTRACT.getAllContractsList.success,
          data,
          suggestedData
        });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getContractList = (
  id,
  harvestYear = harvestYearDetail().name,
  pageNumber = 0,
  recordsPerPage = 50,
  searchTerm
) => {
  let url = `/ntrac/contract/contractList/${id}?pageNumber=${pageNumber}&recordsPerPage=${recordsPerPage}&harvestYear=${harvestYear}`;
  url = searchTerm
    ? `${url}&contractNumberContainingString=${searchTerm}`
    : url;
  return dispatch => {
    dispatch({ type: CONTRACT.getContractsList.start, data: "" });
    return globalApiHandler(url, "get", {}, dispatch)
      .then(response => {
        const responseData = response.data.data;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] = responseData[value].contractNumber;
          return responseData[value];
        });
        const totalPages = response.data.pageData.totalPages;
        const totalElements = response.data.pageData.totalElements;
        dispatch({
          type: CONTRACT.getContractsList.success,
          data: { data, totalPages, totalElements }
        });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const commodityList = () => {
  let url = `/ntrac/commodity/commodityList`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: CONTRACT.getALlCommodityList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getCommodityVariertyList = harvestYearId => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
    let url = `/ntrac/commodityVariety/commodityVarietyList/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }?harvestYear=${harvestYearId}`;
    return globalApiHandler(url, "get", {})
      .then(response => {
        const responseData = response.data.data;
        const suggestedResponseData = response.data.suggestedData;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] = responseData[value].variety;
          return responseData[value];
        });

        let suggestedData = Object.keys(suggestedResponseData).map(value => {
          suggestedResponseData[value]["name"] =
            suggestedResponseData[value].variety;
          return suggestedResponseData[value];
        });
        dispatch({
          type: CONTRACT.getCommodityVariertyList.success,
          data,
          suggestedData
        });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getCounterpartList = (harvestYear = harvestYearDetail().name) => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
    // let url = `/ntrac/counterpart/farmId/${
    //   userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    // }?harvestYear=${harvestYear}`;
    let url = `/ntrac/counterpart/getAllCounterPartyForTicketAndContractScreen?farmId=${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }&harvestYear=${harvestYear}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        // const data = response.data.data;
        const responseData = response.data;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] =
            responseData[value].name +
             `${responseData[value].onBoarded?'    ✅':''}`  + `${!responseData[value].paymentStatus && responseData[value].onBoarded?'    ⚠️':''}`;
          return responseData[value];
        });
        const suggestedData = response.data.suggestedData;
        dispatch({
          type: CONTRACT.getAllCounterpartList.success,
          data,
          suggestedData
        });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getContractType = () => {
  let url = `/ntrac/contracttype`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        const responseData = response.data.data;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] = responseData[value].type;
          return responseData[value];
        });
        dispatch({ type: CONTRACT.getAllContractTypeList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getContractStage = () => {
  let url = `/ntrac/contractstage`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        const responseData = response.data.data;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] = responseData[value].stage;
          return responseData[value];
        });
        dispatch({ type: CONTRACT.getAllContractStageList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getDestinationByType = (
  type,
  harvestYear = harvestYearDetail().name
) => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
    let url = `/ntrac/destination/destinationType/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }/${harvestYear}/?destinationType=${type}`;
    return globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        const suggestedData = response.data.suggestedData;
        dispatch({
          type: CONTRACT.getDestinationByType.success,
          data,
          suggestedData
        });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const InternalDestinationList = (
  type,
  harvestYear = harvestYearDetail().name
) => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
    let url = `/ntrac/destination/destinationType/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }/${harvestYear}/?destinationType=${type}`;
    return globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        const suggestedData = response.data.suggestedData;
        dispatch({
          type: CONTRACT.InternalDestinationList.success,
          data,
          suggestedData
        });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createContract = contractInfo => {
  let date = new Date(contractInfo.maturityDate);
  // contractInfo['maturityDate'] = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
  let url = `/ntrac/contract`;
  return dispatch => {
    return globalApiHandler(url, "post", contractInfo)
      .then(response => {
        const data = response.data;
        dispatch({ type: CONTRACT.create.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: data });
        return data;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
        return err.data;
      });
  };
};

export const updateContract = contractInfo => {
  // let date = new Date(contractInfo.maturityDate)
  // contractInfo['maturityDate'] = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
  let url = `/ntrac/contract/contractnum/${contractInfo.contractNumber}`;
  return dispatch => {
    return globalApiHandler(url, "put", contractInfo)
      .then(response => {
        const data = response.data;
        dispatch({ type: CONTRACT.edit.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: data });
        return data;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
        return err.data;
      });
  };
};

export const deleteContract = contractId => {
  let url = `/ntrac/contract/disable/${contractId}`;
  return dispatch => {
    return globalApiHandler(url, "put", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: CONTRACT.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
        return data;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};
export const clearErrorMessage = () => {
  return dispatch => {
    dispatch({ type: "CLEAR_ERROR" });
  };
};

export const editSelectedContract = data => {
  return dispatch => {
    dispatch({ type: CONTRACT.edit.selected, data });
    dispatch({ type: "FILLING_FORM_MODE", data: true });
  };
};
export const FillingForm = () => {
  return dispatch => {
    dispatch({ type: "FILLING_FORM_MODE", data: true });
  };
};

export const getSelectedContractDetail = contractId => {
  let url = `/ntrac/contract/${contractId}`;
  return dispatch => {
    return globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: CONTRACT.selectedContractDetails.success, data });
        return data;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const setSearchTerm = keyword => {
  return dispatch => {
    console.log(keyword);
    dispatch({ type: CONTRACT.setSearchTerm.success, data: keyword });
  };
};



// WEBPACK FOOTER //
// ./src/modules/contract/action.js